
// Used to list all links as constants
// ---- Media links
export const kYoutubeVideoLink = "https://www.youtube.com/embed/B7O2kDY0jOo"

// ---- External
export const kHachetteLink = "https://www.enseignants.hachette-education.com/recherche/?s=Laboudigue"
export const kMathLabLink = "https://www.youtube.com/@MathLaboudigue"
export const kProgramsLink = "https://www.education.gouv.fr/les-programmes-du-college-3203"

// ---- Mobile app links
export const kAppStoreLink = "https://apps.apple.com/fr/app/ummia/id1582867232"
export const kPlayStoreLink = "https://play.google.com/store/apps/details?id=fr.android.ummia"

// ---- Social networks
export const kYoutubeLink = "https://www.youtube.com/@UmmiaMath"
export const kFacebookLink = "https://www.facebook.com/profile.php?id=61573021902651"
export const kInstagramLink = "https://www.instagram.com/ummia.math/?hl=fr"
export const kPotLink = "https://www.onparticipe.fr/c/hxFQao6j"